module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tv-c87adc622981a557f7a5e841ea9ad1a6.svg";